import { Api } from "../config/request";

const getUserOrdersList = async (data) =>{
    let response= await Api.PostRequest("/getUserOrdersList", data);
    return response.data;
}

const getUserBuyedPoints = async (data) =>{
    let response = await Api.PostRequest("/purchasedPointsListing", data);
    return response.data;
}


const purchaseHistoryApi ={
    getUserOrdersList,
    getUserBuyedPoints
}

export default purchaseHistoryApi;
